import React, { useMemo } from 'react';
import { injectEventMetadata } from '../../utils/eventMetadataTokens';
import { processHashtags } from '../../utils/postPreview';
import OfflineImage from './OfflineImage';
import '../EventPostMeta/EventMetadataTokens.css';

const tags = new Set(['P','DIV','SPAN','BR','B','STRONG','I','EM','U','S','DEL','H1','H2','H3','H4','H5','H6','BLOCKQUOTE','UL','OL','LI','PRE','CODE','MARK','SMALL','SUB','SUP','HR','TABLE','TBODY','THEAD','TR','TH','TD']);
const excluded = new Set(['SCRIPT','STYLE','IFRAME','OBJECT','EMBED','SVG','FORM','INPUT','BUTTON','SELECT','TEXTAREA','VIDEO','AUDIO']);
const classes = /^(mention-mark|hashtag-mark|post-content-link|character-link-mark|surah-link-mark|event-inline-meta(?:__[-\w]+)?|embedded-(?:post|winner)-card(?:__[-\w]+)?|post-countdown[-\w]*|ql-align-(?:center|right|justify)|ql-direction-rtl)$/;

export default function OfflinePostContent({ post, language }) {
  const content = useMemo(() => {
    // Reuse the normal tool formatting, then render a strict read-only subset.
    // No href, event handlers, embeds, profile navigation or remote resources survive.
    const html = processHashtags(injectEventMetadata(post.content || '',post,{}, {},language),post.mentions,language==='ar'?'سورة':'Surah');
    const root = new DOMParser().parseFromString(html,'text/html').body;
    const render = (node,key) => {
      if (node.nodeType === 3) return node.textContent;
      if (node.nodeType !== 1 || excluded.has(node.tagName)) return null;
      if (node.tagName === 'IMG') return <OfflineImage key={key} src={node.getAttribute('src')} alt={node.getAttribute('alt') || ''}/>;
      const children = Array.from(node.childNodes).map((child,index)=>render(child,`${key}:${index}`));
      const tag = node.tagName === 'A' ? 'span' : tags.has(node.tagName) ? node.tagName.toLowerCase() : 'span';
      const className = [...node.classList].filter(value=>classes.test(value)).join(' ');
      const style = {};
      ['color','backgroundColor','textAlign','fontWeight','fontStyle','textDecoration'].forEach(property=>{if(node.style[property])style[property]=node.style[property];});
      return React.createElement(tag,{key,className:className || undefined,style,dir:['rtl','ltr','auto'].includes(node.dir)?node.dir:undefined}, ...(['br','hr'].includes(tag)?[]:children));
    };
    return Array.from(root.childNodes).map((node,index)=>render(node,`${index}`));
  },[post,language]);
  return <div className="post-content post-content--full cached-post-content" dir="auto">{content}</div>;
}
